import { parseQueryString, replaceQueryString } from "@common/lib/url";
import { type YouTubeVideoProps } from "./component";

export const getVideoId = (url: string | undefined): string | undefined => {
  if (!url) return;

  const qs = parseQueryString(url) || {};
  if (url.includes("//www.youtube.com/watch")) {
    return qs.v;
  }

  const match = url.match(/\/\/youtu\.be\/([^/]+)/);
  if (match) {
    return match[1];
  }
};

export const getSrc = (props: YouTubeVideoProps): string => {
  let videoId = props.videoId;
  let url = props.url || `//youtube.com/embed/${props.videoId}`;

  const qs = parseQueryString(url) || {};
  if (url.includes("//www.youtube.com/watch")) {
    videoId = qs.v;
    url = `//youtube.com/embed/${qs.v}`;
  } else {
    const match = url.match(/\/\/youtu\.be\/([^/]+)/);
    if (match) {
      videoId = match[1];
      url = `//youtube.com/embed/${videoId}`;
    }
  }

  if (props.isBackground) {
    return replaceQueryString(url, {
      ...qs,
      autohide: 1,
      autoplay: 1,
      controls: 0,
      loop: 1,
      mute: 1,
      showinfo: 0,
      playlist: videoId
    });
  }

  return replaceQueryString(url, {
    ...qs,
    autoplay: props.autoPlay ? 1 : 0,
    controls: props.showControls ? 1 : 0,
    loop: props.loop ? 1 : 0,
    mute: props.autoPlay ? 1 : props.mute ? 1 : 0,
    playlist: props.loop ? videoId : qs.playlist
  });
};

export const isYouTubeURL = (url: string | null | undefined) =>
  (url || "").includes("//youtu.be") ||
  (url || "").includes("//youtube.com/embed") ||
  (url || "").includes("//www.youtube.com/watch");
